import React, { Component, Fragment } from 'react';

import { ValidatorForm } from 'react-form-validator-core';
import TextInput from './TextInput';

import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';

class UpdateEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: null,
      emailError: '',
      input: false,
    };
  }

  componentDidMount() {
    this.setState({ email: this.props.email });
  }

  onChange = ({ target }) => {
    this.setState({ [target.name]: target.value });
  };

  processError = errors => {
    const path = errors[0].path;
    return `${path.charAt(0).toUpperCase() + path.slice(1)} ${errors[0].message}`;
  };

  updateUser = () => {
    const { email } = this.state;
    this.props.client
      .mutate({
        mutation: UPDATE_USER,
        variables: {
          userFields: {
            email,
          },
        },
      })
      .then(({ data }) => data.updateUser)
      .then(updateUser => {
        if (updateUser.errors) {
          this.setState({ emailError: this.processError(updateUser.errors) });
        } else {
          this.setState({ input: false });
        }
      });
  };

  render() {
    const { email, emailError, input } = this.state;
    return (
      <Fragment>
        <ValidatorForm className="profile__item" instantValidate={false} onSubmit={() => this.updateUser()}>
          <div className="profile__item--container">
            <div className="profile__item--title"> Email </div>
            {input ? (
              <TextInput
                onChange={this.onChange}
                name="email"
                value={email}
                validators={['isEmail']}
                errorMessages={['Email is not valid']}
                error={emailError}
              />
            ) : (
              <div className="banking-info__data"> {email} </div>
            )}
          </div>
          {input ? (
            <button className="profile__item--save-button" type="submit">
              {' '}
              Save{' '}
            </button>
          ) : (
            <button
              className="profile__item--save-button"
              type="button"
              style={{ display: 'none' }}
              onClick={event => {
                event.preventDefault();
                this.setState({ input: true });
                console.log('CLICK');
              }}>
              {' '}
              Edit{' '}
            </button>
          )}
        </ValidatorForm>
      </Fragment>
    );
  }
}

const UPDATE_USER = gql`
  mutation updateUser($userFields: UserAttributes!) {
    updateUser(userFields: $userFields) {
      user {
        id
      }
      errors {
        path
        message
      }
    }
  }
`;

export default withApollo(UpdateEmail);



// WEBPACK FOOTER //
// ./src/components/NewProfile/UpdateEmail.js